<template>
  <div id="app">
    <div class="top" v-show="$route.name != 'TabIndex' && $route.name != 'TabMine' && $route.name != 'Login' && $route.name != 'NameWrite' && isShowBack">
      <div class="back">
        <van-icon @click="goBack()" name="arrow-left" />
      </div>
    </div>
    <div class="view">
      <keep-alive >
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view class="" v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <!-- <div>
       <van-dialog v-model="initFlag" :show-confirm-button="false" :width="pageWidth1">
        <div style="width:100%;height:400px;padding-left:30px;padding-right:30px;box-sizing: border-box;">
            <div style="height:70px;line-height:70px;color:#07c260;font-size:20px">平台升级通知</div>
            <div style="text-align: justify;color:#666;font-size:16px">亲爱的希望保会员：</div>
            <div style="height:5px"></div>
            <div style="text-align: justify;color:#666;font-size:16px">您好，感谢您使用【希望保投保】小程序，为了更好的保证您的用户体验，特邀请您前往最新升级改版的小程序<span style="font-weight:bold;color:#333;font-size:15px">【希望保保险】</span>。</div>
            <div style="height:10px"></div>
            <div style="text-align: justify;color:#666;font-size:16px">您的账号信息在<span style="font-weight:bold;color:#333;font-size:15px">【希望保保险】</span>小程序登录后不会受到任何影响。</div>
            <div style="height:10px"></div>
            <div style="text-align: justify;color:#666;font-size:16px">如使用过程中发生任何问题均可拨打我们的客服热线<span style="color:#07c260">4008933988</span>进行咨询和反馈。</div>
        </div>
        <div class="dialog-footer">
            <van-button type="primary" style="width:100%;" @click="goNewApp" >前往体验1</van-button>
            <van-button type="primary" style="width:100%;" @click="goNewApp2" >前往体验2</van-button>
            <van-button type="primary" style="width:100%;" > <a href="weixin://dl/business/?t=d6Q3pg3x1vg">前往体验2</a> </van-button>
        </div>
        </van-dialog>
    </div> -->
  </div>
</template>

<script>
import { Icon,Button, Toast,Dialog} from "vant";
import { mapState } from 'vuex'
import axios from "axios";
export default {
  components: {
    [Icon.name]:Icon,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Dialog.name]:Dialog
  },
  data() {
    return {
      pageWidth1: window.innerWidth - 40,
      initFlag:true,
      link:"",
    };
  },
   computed: {
    ...mapState('d2admin/topBack', [
      'isShowBack'
    ])
  },
  watch: {
    $route:function(val){ }
  },
  mounted() {

  },
  beforeDestroy: function () {},
  methods: {
    goBack(){
      history.go(-1)
    },
    
     goNewApp(){
      Dialog.confirm({
        title: '提示',
        message: '接口访问之前',
        confirmButtonText:'前去体验',
          cancelButtonText:'返回修改',
        }).then(async () => {
          let res = await this.$http.get("/api/user/getscheme")
          Dialog.confirm({
            title: '提示',
            message: `接口访问之后 + /api/user/getscheme`,
            confirmButtonText:'前去体验1',
              cancelButtonText:'返回修改1',
            }).then(()=>{
              if(res.code == 0){
                if(res.t){
                  Dialog.confirm({
                    title: '提示',
                    message: `接口返回成功${res.t}`,
                    confirmButtonText:'前去体验2',
                      cancelButtonText:'返回修改2',
                  }).then(()=>{
                      // location.href = res.t
                      location.href = "weixin://dl/business/?t=d6Q3pg3x1vg"
                  })
                }
              }else{
                this.$toast(res.msg);
              }
            })
        }).catch(() => { });
    },
    goNewApp2(){
      wx.miniProgram.navigateTo({
        url: '/pages/initpage/initpage?appid=' + 'wx0127ea77338011da' + '&path=' + '/pages/index/index',
        success: function () {},
      });
    },
    // async goNewApp(){
    //   let res = await this.$http.get("/api/user/getscheme")
    //   if(res.code == 0){
    //     if(res.t){
    //       // location.href = res.t
    //         location.href = "weixin://dl/business/?t=d6Q3pg3x1vg"
    //       }else{
    //         this.$toast(res.msg);
    //       }
    //   }
    // },
    // async goNewApp3(){

    //   let res = await this.$http.get("/api/user/getscheme")
    //   if(res.code == 0){
    //       // location.href = res.t
    //       //在js中如下调用：
    //       if(res.t){
    //         var nextPage = document.createElement('a');
    //         nextPage.setAttribute('href',res.t);
    //         nextPage.click();
    //       }else{
    //         location.href = "https://www.baidu.com/"
    //       }
    //   }else{
    //     this.$toast(res.msg);
    //    }
    // },
    goNewApp3(){
      Dialog.confirm({
        title: '提示',
        message: '接口访问之前',
        confirmButtonText:'前去体验',
          cancelButtonText:'返回修改',
        }).then(async () => {
          let res = await this.$http.get("/api/user/getscheme")
          Dialog.confirm({
            title: '提示',
            message: `接口访问之后 + /api/user/getscheme`,
            confirmButtonText:'前去体验1',
              cancelButtonText:'返回修改1',
            }).then(()=>{
              if(res.code == 0){
                if(res.t){
                  Dialog.confirm({
                    title: '提示',
                    message: `接口返回成功${res.t}`,
                    confirmButtonText:'前去体验2',
                      cancelButtonText:'返回修改2',
                  }).then(()=>{
                      // window.location.href = res.t
                      var nextPage = document.createElement('a');
                      nextPage.setAttribute('href',"weixin://dl/business/?t=d6Q3pg3x1vg");
                      nextPage.click();
                  })
                }
              }else{
                this.$toast(res.msg);
              }
            })
        }).catch(() => { });
    },
  }
};
</script>

<style lang="scss" scoped>
#app{
  display: flex;
  flex-direction: column;
  height: 100%;
  height: 100vh;
  .top{
    height:30px;
    background: #62db9e;
    flex-shrink: 0;
    width: 100%!important;
    z-index: 0;
    .back{
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      .van-icon{
        font-size: 20px;
        color:#fff
      }
    }
  }
  .view{
    flex:1;
    overflow-y: auto;
  }
}
</style>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  /* overflow-y: scroll; */
}
</style>
